/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyLegalIdentifierRequestItem } from './';
import {
    CompanyLegalIdentifierRequestItemFromJSON,
    CompanyLegalIdentifierRequestItemFromJSONTyped,
    CompanyLegalIdentifierRequestItemToJSON,
} from './';

/**
 * Payload to create a CompanyIdentity. `additionalLegalIdentifiers` must NOT include the
 * primary identifier and must share the primary's `countryCode` (enforced server-side; the
 * server returns 400 with a validation error if violated).
 * 
 * @export
 * @interface CreateCompanyIdentityRequest
 */
export interface CreateCompanyIdentityRequest {
    /**
     * 
     * @type {CompanyLegalIdentifierRequestItem}
     * @memberof CreateCompanyIdentityRequest
     */
    primaryLegalIdentifier: CompanyLegalIdentifierRequestItem;
    /**
     * Optional extra legal identifiers. May be empty or omitted.
     * @type {Array<CompanyLegalIdentifierRequestItem>}
     * @memberof CreateCompanyIdentityRequest
     */
    additionalLegalIdentifiers?: Array<CompanyLegalIdentifierRequestItem>;
    /**
     * Optional VAT identification number value (free-form, validated by backend).
     * @type {string}
     * @memberof CreateCompanyIdentityRequest
     */
    vatNumber?: string;
}

/**
 * Check if a given object implements the CreateCompanyIdentityRequest interface.
 */
export function instanceOfCreateCompanyIdentityRequest(value: object): value is CreateCompanyIdentityRequest {
    if (!('primaryLegalIdentifier' in value) || value['primaryLegalIdentifier'] === undefined) return false;
    return true;
}

export function CreateCompanyIdentityRequestFromJSON(json: any): CreateCompanyIdentityRequest {
    return CreateCompanyIdentityRequestFromJSONTyped(json, false);
}

export function CreateCompanyIdentityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompanyIdentityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'primaryLegalIdentifier': CompanyLegalIdentifierRequestItemFromJSON(json['primaryLegalIdentifier']),
        'additionalLegalIdentifiers': json['additionalLegalIdentifiers'] == null ? undefined : ((json['additionalLegalIdentifiers'] as Array<any>).map(CompanyLegalIdentifierRequestItemFromJSON)),
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
    };
}

export function CreateCompanyIdentityRequestToJSON(value?: CreateCompanyIdentityRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'primaryLegalIdentifier': CompanyLegalIdentifierRequestItemToJSON(value['primaryLegalIdentifier']),
        'additionalLegalIdentifiers': value['additionalLegalIdentifiers'] == null ? undefined : ((value['additionalLegalIdentifiers'] as Array<any>).map((v) => CompanyLegalIdentifierRequestItemToJSON(v))),
        'vatNumber': value['vatNumber'],
    };
}

